import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import ImageBlock from 'components/structure/ImageBlock';
import { paddingBuilder } from 'styles/themeUtils';

function SectionOurTeam() {
  return (
    <Section backgroundColor="primary.default">
      <FormattedMessage id="PRESS.TEAM.IMAGE_ALT">
        {([alt]) => (
          <ImageBlock
            alt={alt}
            backgroundImage="office/office.jpg"
          />
        )}
      </FormattedMessage>

      <Block
        padding={{
          default: paddingBuilder.bottom(0),
          desktop: paddingBuilder.left(0),
        }}
      >
        <Typography
          intlKey="PRESS.TEAM.TITLE"
          color="white"
          colorVariant="dark"
          gutterBottom={2}
          variant="title"
        />

        <ul>
          <li>
            <Typography
              intlKey="PRESS.TEAM.EMPLOYEES.NUMBER"
              color="white"
              colorVariant="dark"
              variant="subtitle"
              tag="h3"
              gutterBottom={0.5}
            />

            <Typography
              intlKey="PRESS.TEAM.EMPLOYEES.TEXT"
              color="white"
              colorVariant="dark"
              gutterBottom={2}
            />
          </li>

          <li>
            <Typography
              intlKey="PRESS.TEAM.NATIONALITIES.NUMBER"
              color="white"
              colorVariant="dark"
              variant="subtitle"
              tag="h3"
              gutterBottom={0.5}
            />

            <Typography
              intlKey="PRESS.TEAM.NATIONALITIES.TEXT"
              color="white"
              colorVariant="dark"
              gutterBottom={2}
            />
          </li>

          <li>
            <Typography
              intlKey="PRESS.TEAM.LGBTQ.NUMBER"
              color="white"
              colorVariant="dark"
              variant="subtitle"
              tag="h3"
              gutterBottom={0.5}
            />

            <Typography
              intlKey="PRESS.TEAM.LGBTQ.TEXT.2"
              color="white"
              colorVariant="dark"
              gutterBottom={2}
            />
          </li>

          <li>
            <Typography
              intlKey="PRESS.TEAM.WOMEN.NUMBER"
              color="white"
              colorVariant="dark"
              variant="subtitle"
              tag="h3"
              gutterBottom={0.5}
            />

            <Typography
              intlKey="PRESS.TEAM.WOMEN.TEXT"
              color="white"
              colorVariant="dark"
              gutterBottom={2}
            />
          </li>
        </ul>
      </Block>
    </Section>
  );
}

export default React.memo(SectionOurTeam);
